// Agent permissions for the Admin page's "Agent permissions" dashboard
// (docs/superpowers/specs/2026-10-15-agent-permissions-design.md, the API section):
// - GET /api/agents/policy/?schema=X: the clinic defaults of schema X (the editor's own home
//   schema when none is given), its people, their agents (each with who it is shared with) and the
//   newest changes;
// - GET /api/agents/policy/?schema=* (ALL_CLINICS): every clinic in the editor's reach at once,
//   { all: true, schemas, agents }, each agent with its owner's clinic (schema);
// - PUT /api/agents/policy/defaults/ with { schema, settings }: a schema's full defaults;
// - PUT /api/agents/policy/users/<id>/ with { settings }: a person's override, partial; null
//   clears it.
// Each PUT answers what the GET answers. Every call sends the signed-in user's token, with one
// refresh-and-retry after a 401 (staffRequest); a refusal throws the server's sentence.

import { getBackendURL } from "../components/env";
import { staffRequest } from "./staffRequest";

const PATH = "/api/agents/policy/";
// The schema that asks for every clinic in reach at once: never a clinic's name.
export const ALL_CLINICS = "*";
// What a failure says when the server gave no sentence of its own (a gateway's error page).
const FAILURE = "Agent permissions couldn't be reached. Try again.";

export function fetchAgentPolicy(schema) {
  const url = new URL(`${getBackendURL()}${PATH}`);
  if (schema) url.searchParams.set("schema", schema);
  return staffRequest(url.toString(), { failure: FAILURE });
}

// `settings`: every area, send and auto set (the clinic defaults are never partial).
export function saveAgentPolicyDefaults(schema, settings) {
  return staffRequest(`${getBackendURL()}${PATH}defaults/`, {
    method: "PUT",
    body: { schema, settings },
    failure: FAILURE,
  });
}

// `settingsOrNull`: the keys this person doesn't follow the clinic default for, or null to clear
// the override (they then follow the clinic default in everything).
export function saveAgentPolicyUser(userId, settingsOrNull) {
  return staffRequest(`${getBackendURL()}${PATH}users/${encodeURIComponent(userId)}/`, {
    method: "PUT",
    body: { settings: settingsOrNull },
    failure: FAILURE,
  });
}
